import React from 'react'
import { Input } from '@guillotinaweb/react-gmi'
import { Form } from '@guillotinaweb/react-gmi'
import { useSetState } from 'react-use'
import { stringToSlug } from '@guillotinaweb/react-gmi'

const LANGS = ['es', 'en', 'fr', 'de', 'it']

const initial = {
  nombre: {
    es: '',
    fr: '',
    de: '',
    it: '',
  },
  old_id: '',
  tipo: 'do',
  '@type': 'ZonaGeo',
  id: '',
}

export function ZonaForm({ onSubmit, actionName, title }) {
  const [state, setState] = useSetState(initial)
  const [error, setError] = React.useState(undefined)

  const submit = (ev) => {
    if (state.id === '' || state.nombre.es === '') {
      setError('Id y Nombre requeridos')
      return
    }
    onSubmit(state)
  }

  const setField = (lang) => (value) =>
    setState((st) => ({
      nombre: { ...st.nombre, [lang]: value },
    }))

  const setNombreEs = (value) => {
    setState((st) => ({
      id: stringToSlug(value),
      nombre: { ...st.nombre, es: value },
    }))
  }

  return (
    <Form title={title} onSubmit={submit}>
      {error && <p className="is-warning">{error}</p>}

      <Input
        id={'nombre_' + LANGS[0]}
        placeholder={`Nombre ${LANGS[0]}`}
        value={state.nombre[LANGS[0]]}
        onChange={setNombreEs}
      />

      {LANGS.slice(1).map((lang) => (
        <Input
          id={'nombre_' + lang}
          placeholder={`Nombre ${lang}`}
          value={state.nombre[lang]}
          onChange={setField(lang)}
        />
      ))}

      <Input
        onChange={(ev) => setState({ id: ev })}
        id="id"
        placeholder="ID"
        value={state.id}
      />

      <Input
        onChange={(ev) => setState({ old_id: ev.target.value })}
        id="old_id"
        placeholder="Old Id"
        value={state.old_id}
      />

      <div className="level level-right">
        <button type="submit" className="button is-success">
          {actionName || 'Add'}
        </button>
      </div>
    </Form>
  )
}
